import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Target } from '@sorare/core/src/atoms/icons/Target';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import {
  BodyM,
  BrandL,
  BrandM,
  BrandS,
} from '@sorare/core/src/atoms/typography';
import { fantasy } from '@sorare/core/src/lib/glossary';

import { TutorialBezel } from '../../TutorialBezel';
import cutPlayerCard from '../../assets/cutPlayerCard.webp';

const BottomContentWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--intermediate-unit);
`;
const Img = styled.img`
  width: calc(12 * var(--unit));
  height: 100%;
  position: relative;
  bottom: calc(-1 * var(--double-unit));
  object-fit: cover;
  justify-self: right;
`;
const TargetWrapper = styled(Horizontal)`
  align-self: flex-start;
  padding-top: var(--double-unit);
`;

export const HitScoreTarget = () => {
  return (
    <TutorialBezel color="var(--c-rewards-orange)">
      <Vertical gap={2.5} className="text-center">
        <Vertical center>
          <BrandM>
            <FormattedMessage
              id="HitScoreTarget.title"
              defaultMessage="Hit the score target"
            />
          </BrandM>
          <BodyM color="var(--c-nd-600)">
            <FormattedMessage
              id="HitScoreTarget.description"
              defaultMessage="+x over the average score"
            />
          </BodyM>
        </Vertical>
      </Vertical>
      <BottomContentWrapper>
        <Img alt="" src={cutPlayerCard} />
        <TargetWrapper gap={0.5}>
          <Target />
          <BrandL>
            <FormattedMessage
              {...fantasy.ordinalPoints}
              values={{
                score: 60,
                sup: c => (
                  <BrandS as="sup" color="var(--c-nd-600)">
                    {c}
                  </BrandS>
                ),
              }}
            />
          </BrandL>
        </TargetWrapper>
      </BottomContentWrapper>
    </TutorialBezel>
  );
};
